import * as React from 'react'
import { Card, CardActionArea } from '@material-ui/core'
import { useTranslation, useI18next, Link } from 'gatsby-plugin-react-i18next'
import { displayDate, displayDateWithTime } from 'libs/date/dateUtil'
import WebpImage from 'components/presenter/image/WebpImage'
import JetsoStatusChip from '../JetsoStatusChip'
import JetsoStats from '../JetsoStats'
import * as styles from './create.module.css'

const JetsoCard = ({news}) => {
  const { t } = useTranslation()
  const { navigate } = useI18next()
  const detailPath = `/jetso/detail/?id=${news._id}`
  const onClick = () => navigate(detailPath)
  const SEOLink = (
    <Link
      to={detailPath} 
    />
  )
  const thunmbnailUrl = `${news.posters[0].url}-tn`
  return (
    <Card elevation={2} onClick={onClick}>
      <CardActionArea className={styles.newsCard}>
        <WebpImage className={styles.newsImage} src={thunmbnailUrl} alt={news.title} />
        <div className={styles.newsBody}>
          <p className={styles.title}>{news.title}</p>
          <JetsoStatusChip news={news} />
          {/* <div className={styles.statusRoot}> */}
            {/* <JetsoStats type='views' stats={news.stats.views} /> */}
            {/* <JetsoStats type='likes' stats={news.stats.likes} /> */}
            {/* <JetsoStats type='dislikes' stats={news.stats.dislikes} /> */}
          {/* </div> */}
          <p className={styles.promoteTxt}>{t('jetso.promoteStartAtFormat', {
            date: displayDate(news.promote_start_at) ?? '-'
          })}</p>
          <p className={styles.promoteTxt}>{t('jetso.promoteEndAtFormat', {
            date: displayDate(news.promote_end_at) ?? '-'
          })}</p>
          <div className={styles.space} />
          <p className={styles.createdTxt}>{t('jetso.createdAtFormat', {
            date: displayDateWithTime(news.created_at)
          })}</p>
        </div>
      </CardActionArea>
      {SEOLink}
    </Card>
  )
}

export default JetsoCard